import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BadgeCheck, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { PageShell } from "@/components/AppShell";
import { Input } from "@/components/ui/input";
import { CertificateCard } from "@/pages/Certificates";

export default function Verify() {
  const { credentialId } = useParams();
  const navigate = useNavigate();
  const [id, setId] = useState(credentialId || "");
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!credentialId) return;
    setState("loading");
    api.get(`/certificates/verify/${credentialId}`).then(({ data }) => setState(data)).catch(() => setState("missing"));
  }, [credentialId]);

  return (
    <PageShell>
      <div className="overline-label">Credential verification</div>
      <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter">Verify a credential</h1>
      <form onSubmit={(e) => { e.preventDefault(); if (id.trim()) navigate(`/verify/${id.trim().toUpperCase()}`); }} className="mt-8 flex max-w-lg gap-2">
        <Input data-testid="verify-id-input" value={id} onChange={(e) => setId(e.target.value)} placeholder="CIAS-F-XXXXXXXX" className="h-11 rounded-sm font-mono" aria-label="Credential ID" />
        <button data-testid="verify-submit-button" className="rounded-sm bg-brand-primary px-5 text-sm font-semibold text-brand-primary-fg">Verify</button>
      </form>
      {state === "missing" && <p data-testid="verify-not-found" className="mt-8 flex items-center gap-2 text-destructive"><XCircle className="h-5 w-5" /> No credential found with this ID.</p>}
      {state && typeof state === "object" && (
        <div className="mt-10">
          <p data-testid="verify-valid" className="mb-4 flex items-center gap-2 font-semibold text-brand-accent"><BadgeCheck className="h-5 w-5" /> Valid credential issued by {state.issuer}</p>
          <CertificateCard c={state} />
        </div>
      )}
    </PageShell>
  );
}
